import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Errors } from "../../core/models/errors.module";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../../core/services/auth.service";
import { CommonService } from "../../core/services/common.service";

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

    title: String = '';
    errors: Errors = new Errors();
    isSubmitting = false;
    authForm: FormGroup;
    token: null;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authService: AuthService,
        private fb: FormBuilder,
        private commonService: CommonService
    ) {
        this.authForm = this.fb.group({
            'email': ['', Validators.required],
        });
    }

    ngOnInit() {
        this.route.url.subscribe(data => {
            this.title = 'Send Password Reset link';
        });
    }

    sendMail() {
        this.errors = new Errors();

        this.authService
            .sendPasswordResetMail(this.authForm.value).subscribe(
            response => {
                if (response['success']) {
                    this.commonService.notifications.success('Success', 'Email Sent Successfully');
                }
                else {
                    this.commonService.notifications.error('Error', 'Something Went Wrong, Try again!')
                }
            }
        );
    }

    goToLogin() {
        this.router.navigateByUrl('/login');
    }


}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/login/forgot-password/forgot-password.component.ts